module.exports = __webpack_public_path__ + "static/media/ants_logo.80bf80a4.png";